import { STAGE_GROUPS } from "../lib/types";

/** <option>s for a status <select>, grouped by stage. */
export function StatusOptions() {
  return (
    <>
      {STAGE_GROUPS.map((g) => (
        <optgroup key={g.stage} label={g.stage}>
          {g.statuses.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
